import React from 'react';
import { CalculatorsContextData } from './types';

export const CalculatorsContext = React.createContext<CalculatorsContextData>(
  {} as CalculatorsContextData,
);

export default CalculatorsContext;
